module.exports = __webpack_public_path__ + "img/WeChat-&-AliPay-QR-Payments-at-Grass-Roots.d1e2d0a1.jpg";